// src/lib/useIsMobile.js — chantier responsive Lot 0.
//
// Hook RÉSERVÉ aux SWAPS DE LAYOUT durs (décision Dimitri : CSS-first par défaut ;
// le hook seulement quand le CSS ne suffit pas — ex. effondrement Inbox 3-panneaux
// en navigation liste→thread→composer, ou bascule master⟷détail de LogementsPanel
// où le composant doit RENDRE un arbre différent selon la largeur).
//
// Pour de la simple mise en page (grilles qui se replient, tables scroll-x,
// modales plein écran), NE PAS utiliser ce hook → utiliser les classes CSS de
// fontsStyle (.fbz-row, .fbz-master-detail, .fbz-table-wrap, .fbz-modal-sheet).
//
// Aligné sur le breakpoint md (BP.md = 768) : `true` quand viewport < 768px.

import { useState, useEffect } from "react";
import { BP } from "./ui";

/**
 * useIsMobile(maxWidth=BP.md) — true si le viewport est « mobile » (< maxWidth).
 * SSR/no-matchMedia safe : retourne false si window/matchMedia indisponible.
 * @param {number} [maxWidth] seuil en px (défaut BP.md = 768).
 * @returns {boolean}
 */
export function useIsMobile(maxWidth = BP.md) {
  const query = `(max-width: ${maxWidth - 0.02}px)`;
  const get = () =>
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia(query).matches;

  const [isMobile, setIsMobile] = useState(get);

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    )
      return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    // addEventListener moderne ; fallback addListener (Safari ancien).
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}

export default useIsMobile;
